<template lang="">
  <v-app id="inspire">
    <v-card>
       
        <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
        >
            <v-tab
                v-for="item in items"
                :key="item.titulo"
            >
                {{ item.titulo }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item
                v-for="(item,index) in items"
                :key="item.titulo"
            >

                <v-card
                color="basil"
                flat
                >
                <div class="container">
                 <menu-historico @getData="getData" @getAlarms="getAlarms" :available_alarms="available_alarms"
                        :available_sections="available_sections"
                        :desde="index+1" />
                </div>
                    <v-data-table
                        :headers="item.cabeceras"
                        :items="item.datos"
                        item-key="id"
                        :loading="cargando"
                        loading-text="Loading... Please wait"
                        

                        class="elevation-1">
                        <template v-if="item.id==1" v-slot:item.elemento="{ item }">
                            <span>Potencia</span>
                        </template>

                        <template  v-slot:item.created_at="{ item }">
                            <span> {{formatData(item.created_at)}}</span>
                        </template>
                        <template  v-slot:item.alarm_ids="{ item }">
                            <v-tooltip v-for="(aa,index) in item.alarm_ids"  :key="index" bottom color="success">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip  v-bind="attrs" v-on="on" class="ma-2" color="primary" >{{aa.name}}</v-chip>
                                </template>
                                <span>{{aa.fecha_inicio}} - {{aa.fecha_fin}}</span>
                            </v-tooltip>
                        </template>
                         
                        
                    </v-data-table>

                    <!-- <v-card-text>{{ item.datos }}</v-card-text> -->
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
      </v-app>

</template>
<script>
import MenuHistorico from '../components/historicos/MenuHistorico.vue'
export default {
    components: {
        MenuHistorico,
    },
    computed: {
        itemsTratados(){
            let res= []
            return res
        }
    },
  
    methods: {
        async getData(payload){
            this.cargando=true;
            console.log(`VIENEN DATOS `)
            const {fecha_fin,fecha_inicio,alarmas} = payload
            console.log(payload)
            // const datos_consultados = await this.axios.get(`http://192.168.2.11::${process.env.VUE_APP_RUTA_PORT}/potencia_en_alarmas/fechainicio/${fecha_inicio}/fechafin/${fecha_fin}`)
            const datos_consultados = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/potencia_en_alarmas/fechainicio/${fecha_inicio}/fechafin/${fecha_fin}`,
            {
                params:{
                    'alarms':alarmas
                }

            })
            // const datos_consultados = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/potencia_en_alarmas`)
            // console.log(datos_consultados)
            this.items[0].datos = datos_consultados.data;
            this.cargando=false;
        },
        async getAlarms(payload){
            this.cargando=true;
            console.log(`VIENEN alarmas `)
            console.log(payload)
            const {alarma,fecha_fin,fecha_inicio,seccion} = payload
            let alarmaUtil=(alarma!=0)?alarma.id:0
            let seccionUtil=(seccion!=0)?seccion.id:0
            
            // const datos_consultados = await this.axios.get(`http://192.168.2.11::${process.env.VUE_APP_RUTA_PORT}/historico_alarmas/alarma/${alarmaUtil}/seccion/${seccionUtil}/fechainicio/${fecha_inicio}/fechafin/${fecha_fin}`)
            const datos_consultados = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/historico_alarmas/alarma/${alarmaUtil}/seccion/${seccionUtil}/fechainicio/${fecha_inicio}/fechafin/${fecha_fin}`)
            console.log(datos_consultados)
            this.items[1].datos = datos_consultados.data;
            this.cargando=false;
        },
        formatData(st){
            const fecha_hora_actual_pre = new Date(st).toLocaleString('es-ES',{hour12 : false});
            let feho = fecha_hora_actual_pre.split(', ')
            const hora = feho[1]
            const fecha = feho[0].split('/').reverse().join('-')
            return fecha+" "+hora
        },
        formatear(el) {
            const pos = el['fecha'].indexOf(".");
            let limpio = el['fecha'].substring(0,pos).replace('T',' ');
    
	        return limpio;
        }
    },
    data() {
        return {
            cargando:false,
            ruta_api:process.env.VUE_APP_RUTA_API,
            available_alarms:[],
            available_sections:[],
            tab: null,
            items: [
          {
            'titulo': 'Datos',
            'datos':[],
            'id':1,
            'pos':0,
            'cabeceras':[ 
                {
                    text: 'Elemento',
                    align: 'start',
                    sortable: false,
                    value: 'elemento',
                },
                {
                    text: 'Fecha',
                    align: 'start',
                    sortable: true,
                    value: 'created_at',
                },
                {
                    text: 'Valor',
                    align: 'start',
                    sortable: true,
                    value: 'value',
                },
                {
                    text: 'Alarmas',
                    align: 'start',
                    sortable: false,
                    value: 'alarm_ids',
                }
            ],
          },
          {
            'titulo':'Alarmas',
            'datos':[],
            'id':2,
            'pos':1,
            'cabeceras':[ 
                {
                    text: 'Sección',
                    align: 'start',
                    sortable: true,
                    value: 'section_name',
                },
                {
                    text: 'Alarma',
                    align: 'start',
                    sortable: false,
                    value: 'alarm_name',
                },
                {
                    text: 'Valor',
                    align: 'start',
                    sortable: true,
                    value: 'valor',
                },
                {
                    text: 'Fecha',
                    align: 'start',
                    sortable: true,
                    value: 'created_at',
                }
            ],
          }
        ],
        }
    },
    async created () {
        const ds = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/datos`)
        this.items[0].datos= ds.data; 

        const av_alarms = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/available_alarms`)
        this.available_alarms=av_alarms.data;
        
        const av_sections = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/available_sections`)
        this.available_sections = av_sections.data;
        
        const ds1 = await this.axios.get(`${process.env.VUE_APP_RUTA_API}:${process.env.VUE_APP_RUTA_PORT}/alarmas`)
        this.items[1].datos= ds1.data;
    },
    
}
</script>
<style lang="">
    
</style>